const API_BASE_URL = "https://backend.trainfitness.ai/"
// const API_BASE_URL = "http://127.0.0.1:5001/train-165d3/us-central1/apiV2/"
export { API_BASE_URL };